import React, { useEffect, useState , useContext} from "react";
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Link} from "react-router-dom";
import { Spinner } from "react-bootstrap";
import $ from 'jquery';
import { useParams, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import UrlHouse from "../../utils/UrlHouse";
import DefaultProfile from '../../asset/default_profile.png';
import VerifiedBadge from '../../asset/verified_badge.png';
import { AppContext } from "../../utils/AppContext";
import Logo from '../../asset/logo_long_transparent_cropped.png';
import "../../spinner.css";

import {Helmet} from "react-helmet";
import axios from 'axios';
import { Label } from "recharts";

const ConfirmAdPage = () => {

    const appContext = useContext(AppContext);
    const navigate = useNavigate();
    const params = useParams();
    const [isLoaded, setIsLoaded] = useState(false);

    const [adData, setAdData] = useState({
        adName: "",
        adType: 101,
        startDate: "",
        endDate: "",
        adBudget: 0
    })

    const desktopStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px"
        },

        selectImageButtonStyle: {
            display: "none"
        },

        imagePreviewStyle: {
            height: "30vh",
            margin: "10px"
        },

        sendButtonStyle: {
            
        }
    }

    const mobileStyles = {
        mainContainerStyle: {
            width: "100%",
            padding: "30px",
        },

        selectImageButtonStyle: {
            display: 'none'
        },

        imagePreviewStyle: {
            height: "30vh",
            margin: "10px"
        },

        sendButtonStyle: {
            
        }
    }

    const styles = appContext.mobileMode ? mobileStyles : desktopStyles

    useEffect(() => {
      init();
    }, [])

    const init = () => {
        $.ajax({
            type: "POST",
            url: UrlHouse.CONFIRM_AD_INIT,
            data: JSON.stringify({
                email: localStorage.getItem("email"), password: localStorage.getItem("password"), ad_id: params.id
            }),
            dataType: "json",
            success: function (response) {
                if(response.result === 1){
                    setIsLoaded(true);
                    setAdData({
                        adName: response.ad_name,
                        adType: response.ad_type,
                        startDate: response.start_date,
                        endDate: response.end_date,
                        adBudget: response.budget,
                    });
                }else if(response.result === 2){
                    navigate('/dashboard/ads/create/payment/'+params.id);
                }else{
                    navigate('/dashboard/ads/create/finish/'+params.id);
                }
            },
            error: function(e){
                navigate('/dashboard/ads');
            }
        });
    }

    const [linkPreview, setLinkPreview] = useState({
        title: "Woilo - Photo, Video, Chat, NFTs",
        description: "Woilo - Photo, Video, Chat, NFTs",
        url: "",
        imageUrl: ""
    })

	const onSubmitButtonClick = async() => {
        navigate('/dashboard/ads/create/invoice/'+params.id);
	};

    function getAdType(){
        if(adData.adType === 101){
            return "Iklan Foto";
        }
        if(adData.adType === 102){
            return "Iklan Video";
        }
        if(adData.adType === 103){
            return "Iklan Karosel";
        }
        return "Iklan Foto";
    }

    function getAdBudget(){
        const formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
        });
        return formatter.format(adData.adBudget);
    }

    return(
        <>
            <div style={styles.outerContainerStyle}>
                <Helmet>
                    <title>{linkPreview.title}</title>

                    <meta property="og:title" content={linkPreview.title} />
                    <meta property="og:description" content={linkPreview.description} />
                    <meta property="og:image" content={linkPreview.imageUrl} />
                    <meta property="og:url" content={linkPreview.url} />
                    <meta property="og:type" content="website"/>

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:domain" content="woilo.com" />
                    <meta property="twitter:url" content={linkPreview.url} />
                    <meta name="twitter:title" content={linkPreview.title} />
                    <meta name="twitter:description" content={linkPreview.description} />
                    <meta name="twitter:image" content={linkPreview.imageUrl} />
                </Helmet>
                {
                    isLoaded?<div style={styles.mainContainerStyle}>
                        <h1>Iklan Berhasil dibuat</h1>
                        <hr></hr>
                        <div>
                            <h5>Nama Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{adData.adName}</h6>
                            <h5>Jenis Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{getAdType()}</h6>
                            <h5>Tanggal Mulai</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{adData.startDate}</h6>
                            <h5>Tanggal Selesai</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{adData.endDate}</h6>
                            <h5>Biaya Pengeluaran Iklan</h5>
                            <h6 style={{color: appContext.colors.primaryGrey}}>{getAdBudget()}</h6>
                        </div>


                        <div>
                            <Form>
                                <Form.Group as={Row} className="mb-3">
                                    <Col sm={{ span: 12}} style={{display: "flex"}}>
                                        <Button onClick={onSubmitButtonClick} style={styles.sendButtonStyle}>Konfirmasi Iklan</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>:<></>
                    
                }
            </div>
        </>
    )
}

export default ConfirmAdPage;